module.exports = __webpack_public_path__ + "static/media/one.507a0e33.png";